import AjaxService, { validateResponse } from '../services/ajax-service';

import { handleServerError } from 'shared-services/error-service';

export const fetchTasksViews = ({ projectId, offset, limit }) => {
    // return Promise.resolve({
    //     items: [
    //         // {
    //         //     id: 0,
    //         //     type: 'myTasks',
    //         //     config: {
    //         //         filter: {}
    //         //     },
    //         //     is_auto_save: true
    //         // }
    //     ],
    //     hasMore: false
    // });

    return AjaxService({
        method: 'get',
        url: 'tasks_layouts',
        params: {
            project_id: projectId,
            offset,
            limit
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const createTasksView = ({ type, project_id, config, is_shared, is_auto_save, is_default, name }) => {
    return AjaxService({
        method: 'post',
        url: 'tasks_layouts',
        data: {
            type,
            project_id,
            config,
            is_shared,
            is_auto_save,
            is_default,
            name
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const updateTasksView = (tasksViewId, { config, is_shared, is_default, is_pinned, name }) => {
    return AjaxService({
        method: 'put',
        url: `tasks_layouts/${tasksViewId}`,
        data: {
            config,
            is_shared,
            is_default,
            is_pinned,
            name
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeTasksView = tasksViewId => {
    return AjaxService({
        method: 'delete',
        url: `tasks_layouts/${tasksViewId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}
